module.exports = __webpack_public_path__ + "static/media/ic-clear.2ca824d3.svg";